// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"0f0dc144","839":"f4e7249d"}[chunkId] + ".chunk.js";
};